import React, {Component} from 'react';  

import "bootstrap/dist/css/bootstrap.min.css";


import SignUpForm1 from './SignUpForm1';
import SignUpForm2 from './SignUpForm2';


class SignUpForm extends Component{

    state = {
        step: 1,
    }
    getSignUpParams = (data) => {

        console.log("getSignUpParams in parent: ", data );
        this.setState({ step:  2 });
         
    }

    backStep = () =>{ 
        this.setState({step: 1});
    }
    
    nextStep = () =>{ 
        this.setState({step: 2});
    }

    render(){

        let { step } = this.state;
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        console.log( params.get('code') );
        if( code !== null ) step = 2;

        //clean session 
        let XSmode = 'vip'
        sessionStorage.removeItem(XSmode + '-xsValidation') ; 
        sessionStorage.removeItem(XSmode + '-fullname') ;
        sessionStorage.removeItem(XSmode + '-email') ;
        sessionStorage.removeItem(XSmode + '-phone') ;
        XSmode = 'model'
        sessionStorage.removeItem(XSmode + '-xsValidation') ; 
        sessionStorage.removeItem(XSmode + '-fullname') ;
        sessionStorage.removeItem(XSmode + '-email') ;
        sessionStorage.removeItem(XSmode + '-phone') ;

        switch (step){
            case 2: 
            return (
                <SignUpForm2 code={code} backStep={this.backStep } /> 
            );
            default:
                return (
                    <SignUpForm1 getSignUpParams={this.getSignUpParams} nextStep={this.nextStep } /> 
                );
        }
    }   

}

export default SignUpForm;

